import SiteWithPendingSynchronizationAutocomplete from "entities/tsoTests/shared/SiteWithPendingSynchronizationAutocomplete";
import { required, SimpleForm } from "react-admin";
import { FieldValues } from "react-hook-form";
import CustomDateTimeInput from "shared/components/inputs/CustomDateTimeInput";
import { SiteContryEnum } from "shared/enums/globalEnums";
import { SiteResourcesEnum } from "shared/enums/resourceMappings";
import { validatePlanningTime } from "shared/utils/validations";
import TestFcrDInitialFields from "../fcrD/TestFcrDInitialFields";
import TestFcrNInitialFields from "../fcrN/TestFcrNInitialFields";
import TestFingridAfrrInitialFields from "../fingridAfrr/TestFingridAfrrInitialFields";
import useFingridTestGenericInitialForm from "./hooks/useFingridTestGenericInitialForm";
import SiteSelectionAlert from "./SiteSelectionAlert";
import { TestTypeEnum } from "./types";

export interface InitialFormProps {
  onSubmit: (data: FieldValues) => void;
  testType: TestTypeEnum;
}

const FingridTestGenericInitialForm = ({ onSubmit, testType }: InitialFormProps) => {
  const { sitesNotInTestMode, fetchSitesData } = useFingridTestGenericInitialForm();

  return (
    <SimpleForm
      onSubmit={onSubmit}
      sx={{
        "& .MuiStack-root": {
          display: "grid",
          gridTemplateColumns: "1fr 1fr",
          gap: 2,
        },
      }}
    >
      <SiteSelectionAlert fetchSitesData={fetchSitesData} sitesNotInTestMode={sitesNotInTestMode} />
      <SiteWithPendingSynchronizationAutocomplete
        referenceArrayInputProps={{
          reference: SiteResourcesEnum.Sites,
          source: "siteIds",
          filter: { country__in: [SiteContryEnum.Finland, SiteContryEnum.Sweden] },
        }}
        autocompleteArrayInputProps={{
          validate: required(),
        }}
      />
      <CustomDateTimeInput source="startDate" validate={[required(), validatePlanningTime]} minDateTime={new Date()} />
      {testType === TestTypeEnum.fcrN && <TestFcrNInitialFields />}
      {testType === TestTypeEnum.fcrD && <TestFcrDInitialFields />}
      {testType === TestTypeEnum.finlandAfrr && <TestFingridAfrrInitialFields />}
    </SimpleForm>
  );
};

export default FingridTestGenericInitialForm;
